import { all, call, takeLatest } from 'redux-saga/effects';
import { requestPuppy } from '@wix/da-http-client';
import { PapiDaSharedUserSendotp, PapiRequestDaSharedUserSendotp } from '@wix/da-papi-types';
import {
  sendOneTimePasswordRequest,
  sendOneTimePasswordRequestFailure,
  sendOneTimePasswordRequestSuccess,
} from './actions';
import { handleNetworkResponse } from '../networking/utils';

/**
 * POST /user/send_otp (dashared puppy). Adjust `url` if the backend route differs.
 */
function* handleSendOneTimePassword(action: ReturnType<typeof sendOneTimePasswordRequest>) {
  const data: PapiRequestDaSharedUserSendotp = action.payload.data;

  const response: PapiDaSharedUserSendotp = yield requestPuppy(
    {
      method: 'POST',
      url: 'user/sendotp',
      data,
    },
    undefined,
    'dashared'
  );

  yield call(
    handleNetworkResponse,
    response,
    sendOneTimePasswordRequestSuccess,
    sendOneTimePasswordRequestFailure,
    'Failed to send one-time password'
  );
}

export function* oneTimePasswordSaga() {
  yield all([takeLatest(sendOneTimePasswordRequest, handleSendOneTimePassword)]);
}
